// External links open in new tab
        document.querySelectorAll('a[href]').forEach(function(a) {
            if (a.hostname && a.hostname !== location.hostname) {
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'noopener');
            }
        });

        // Scroll reveal
        function initRevealObserver() {
            const revealElements = document.querySelectorAll('.reveal:not(.visible)');
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
            revealElements.forEach(el => observer.observe(el));
        }
        initRevealObserver();

        // Sticky header
        const header = document.getElementById('mainHeader');
        window.addEventListener('scroll', () => {
            header.classList.toggle('scrolled', window.scrollY > 50);
        });

        // Mobile menu
        const hamburgerBtn = document.getElementById('hamburgerBtn');
        const mobileMenu = document.getElementById('mobileMenu');
        hamburgerBtn.addEventListener('click', () => {
            hamburgerBtn.classList.toggle('active');
            mobileMenu.classList.toggle('open');
            document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
        });
        function closeMobileMenu() {
            hamburgerBtn.classList.remove('active');
            mobileMenu.classList.remove('open');
            document.body.style.overflow = '';
        }
        window.addEventListener('resize', function() {
            if (window.innerWidth > 1024 && mobileMenu.classList.contains('open')) {
                closeMobileMenu();
            }
        });

        // Cart
        function addToCart() {
            const el = document.getElementById('cartCount');
            el.textContent = parseInt(el.textContent) + 1;
        }

        // PDP quantity
        function updateQty(delta) {
            const el = document.getElementById('pdpQty');
            const input = document.getElementById('pdpQtyInput');
            const val = Math.max(1, parseInt(el.textContent) + delta);
            el.textContent = val;
            if (input) input.value = val;
        }

        // PDP Slider
        (function () {
            let currentSlide = 0;
            const slider = document.getElementById('pdpSlider');
            const track = document.getElementById('pdpTrack');
            const thumbsContainer = document.getElementById('pdpThumbs');
            if (!slider || !track) return;
            const slides = track.querySelectorAll('.pdp-slide');
            const thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.pdp-thumb') : [];
            const total = slides.length;

            function updateSlider(animate) {
                if (animate === false) track.style.transition = 'none';
                else track.style.transition = '';
                track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
                thumbs.forEach((t, i) => t.classList.toggle('active', i === currentSlide));
                slides.forEach((s, i) => {
                    const vid = s.querySelector('video');
                    if (vid) { if (i === currentSlide) vid.play(); else vid.pause(); }
                });
            }

            window.goToSlide = function (idx) {
                currentSlide = Math.max(0, Math.min(idx, total - 1));
                updateSlider();
            };

            let startX = 0, startY = 0, lastX = 0, dragging = false, moved = false;
            let velocity = 0, lastTime = 0;
            const threshold = 20;

            function onStart(e) {
                dragging = true; moved = false; velocity = 0;
                startX = e.touches ? e.touches[0].clientX : e.clientX;
                startY = e.touches ? e.touches[0].clientY : e.clientY;
                lastX = startX;
                lastTime = Date.now();
                slider.classList.add('grabbing');
            }
            function onMove(e) {
                if (!dragging) return;
                const x = e.touches ? e.touches[0].clientX : e.clientX;
                const y = e.touches ? e.touches[0].clientY : e.clientY;
                const dx = x - startX;
                const dy = y - startY;
                if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
                    e.preventDefault();
                    moved = true;
                    var now = Date.now();
                    var dt = now - lastTime;
                    if (dt > 0) velocity = (x - lastX) / dt;
                    lastX = x; lastTime = now;
                    var pct = currentSlide * 100 - (dx / slider.offsetWidth) * 100;
                    track.style.transition = 'none';
                    track.style.transform = 'translateX(-' + pct + '%)';
                }
            }
            function onEnd(e) {
                if (!dragging) return;
                dragging = false;
                slider.classList.remove('grabbing');
                var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
                var dx = x - startX;
                var fast = Math.abs(velocity) > 0.3;
                if (fast || Math.abs(dx) > threshold) {
                    var dir = fast ? velocity : dx;
                    if (dir < 0 && currentSlide < total - 1) currentSlide++;
                    else if (dir > 0 && currentSlide > 0) currentSlide--;
                }
                updateSlider();
            }

            slider.addEventListener('mousedown', onStart);
            slider.addEventListener('mousemove', onMove);
            slider.addEventListener('mouseup', onEnd);
            slider.addEventListener('mouseleave', (e) => { if (dragging) onEnd(e); });
            slider.addEventListener('touchstart', onStart, { passive: true });
            slider.addEventListener('touchmove', onMove, { passive: false });
            slider.addEventListener('touchend', onEnd);

            slider.addEventListener('click', (e) => { if (moved) e.preventDefault(); });
        })();

        // Cocktails filter
        document.querySelectorAll('.cocktail-filter').forEach(btn => {
            btn.addEventListener('click', function () {
                document.querySelectorAll('.cocktail-filter').forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                const filter = this.dataset.filter;
                document.querySelectorAll('#cocktailsBlogGrid .cocktail-card').forEach(card => {
                    if (filter === 'all' || card.dataset.spirit === filter) {
                        card.style.display = '';
                    } else {
                        card.style.display = 'none';
                    }
                });
            });
        });

        // Story Process Slideshow
        (function () {
            const section = document.getElementById('storyProcess');
            if (!section) return;
            const images = section.querySelectorAll('.story-process-img');
            const steps = section.querySelectorAll('.story-step');
            const counter = section.querySelector('.current-num');
            const progressBar = section.querySelector('.story-process-progress-bar');
            const total = steps.length;
            let current = 0;
            let autoTimer;

            function goTo(idx) {
                current = ((idx % total) + total) % total;
                images.forEach((img, i) => img.classList.toggle('active', i === current));
                steps.forEach((step, i) => step.classList.toggle('active', i === current));
                counter.textContent = String(current + 1).padStart(2, '0');
                progressBar.style.width = ((current + 1) / total * 100) + '%';
                resetAuto();
            }

            steps.forEach(step => {
                step.addEventListener('click', () => goTo(parseInt(step.dataset.step)));
            });

            window.storyNext = () => goTo(current + 1);
            window.storyPrev = () => goTo(current - 1);

            function resetAuto() {
                clearInterval(autoTimer);
                autoTimer = setInterval(() => goTo(current + 1), 5000);
            }
            resetAuto();
        })();

        // FAQ menu toggle & filter
        function initFaq() {
            const menu = document.querySelectorAll('.faq-menu a');
            const items = document.querySelectorAll('.faq-content .faq-item');
            if (!menu.length) return;
            function filterFaq(cat) {
                items.forEach(item => {
                    item.style.display = item.dataset.cat === cat ? '' : 'none';
                    item.classList.remove('open');
                });
            }
            menu.forEach(link => {
                link.addEventListener('click', function () {
                    menu.forEach(a => a.classList.remove('active'));
                    this.classList.add('active');
                    filterFaq(this.dataset.cat);
                });
            });
            filterFaq('general');
        }
        initFaq();

        // ═══════════════════════════════════════════════
        //  SHOPIFY THEME EDITOR — SECTION EVENTS
        // ═══════════════════════════════════════════════
        // Re-initialize JS when sections are loaded, reordered, or selected in the editor.

        function initSection(container) {
            if (!container) return;

            // Re-init reveal animations for new/updated sections
            const reveals = container.querySelectorAll('.reveal:not(.visible)');
            if (reveals.length) initRevealObserver();

            // Hero video — ensure autoplay after editor load
            const video = container.querySelector('.hero-video');
            if (video) video.play();

            // PDP slider — re-init if present
            const slider = container.querySelector('#pdpSlider');
            if (slider) {
                // Slider is self-initializing via IIFE above; trigger re-init by dispatching load
                slider.dispatchEvent(new Event('load'));
            }

            // Story process slideshow
            if (container.querySelector('#storyProcess')) {
                // Already self-initializing via IIFE
            }

            // FAQ
            if (container.querySelector('.faq-menu')) {
                initFaq();
            }

            // Cocktail filters
            const filters = container.querySelectorAll('.cocktail-filter');
            if (filters.length) {
                filters.forEach(btn => {
                    btn.addEventListener('click', function () {
                        filters.forEach(b => b.classList.remove('active'));
                        this.classList.add('active');
                        const filter = this.dataset.filter;
                        container.querySelectorAll('.cocktail-card').forEach(card => {
                            card.style.display = (filter === 'all' || card.dataset.spirit === filter) ? '' : 'none';
                        });
                    });
                });
            }
        }

        document.addEventListener('shopify:section:load', function (e) {
            initSection(e.target);
        });

        document.addEventListener('shopify:section:reorder', function () {
            initRevealObserver();
        });

        document.addEventListener('shopify:section:select', function (e) {
            // Scroll the selected section into view in the editor
            if (e.target) e.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        document.addEventListener('shopify:block:select', function (e) {
            if (e.target) e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });